import React from "react";
import { Container } from "reactstrap";
import VVSTable from "components/form-control/VVSTable";
import { CommonButton } from "components/Common/ButtonCommon";

const KPIAssignment = () => {
  return (
    <div className="page-content">
      <Container fluid>
        <VVSTable
          showExportExcel
          title="Chỉ tiêu cho nhân viên"
          name="KPIAssignment"
        />
      </Container>
    </div>
  );
};

export default KPIAssignment;
